import Styled from "./progressBar.style";
export { default } from "./progressBar";
const { ProgressScale } = Styled;
export { ProgressScale };
